import { router } from "@inertiajs/react";
import * as Sentry from "@sentry/react";

// Track Inertia page changes as Sentry transactions
export const setupInertiaTracking = () => {
  router.on("start", (event) => {
    Sentry.addBreadcrumb({
      message: `Navigating to ${event.detail.visit.url}`,
      category: "navigation",
      level: "info",
    });
  });

  router.on("success", (event) => {
    // Set the current page URL for context
    Sentry.setTag("page.url", event.detail.page.url);
    Sentry.setTag("page.component", event.detail.page.component);
  });

  router.on("error", (errors) => {
    // Report Inertia errors to Sentry
    Object.entries(errors.detail.errors).forEach(([field, messages]) => {
      Sentry.addBreadcrumb({
        message: `Validation error on ${field}: ${Array.isArray(messages) ? messages.join(", ") : messages}`,
        category: "validation",
        level: "warning",
      });
    });
  });
};
